import React from 'react';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import PlatformSection from './PlatformSection';
import ExcellenceSection from './ExcellenceSection';
import TestimonialSection from './TestimonialSection';
import EmployeeExperienceSection from './EmployeeExperienceSection';
import Footer from './Footer';
import FAQ from './FAQ';
import ScrollToTopButton from './ScrollToTopButton';
import HomepageCtaSection from './HomepageCtaSection';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen overflow-x-hidden bg-appbg text-ink">
      <div className="mx-auto flex min-h-screen max-w-[1728px] flex-col">
        <Navbar />
        <main className="flex-1">
          <HeroSection />
          <PlatformSection />
          <ExcellenceSection />
          <TestimonialSection />
          <EmployeeExperienceSection />
          <FAQ />
          <HomepageCtaSection />
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </div>
  );
};

export default Layout;
